<div class="container">
  <div style="text-align:center">
    <h1>
      <span class="label label-success">Working with Camera using Angular</span>
    </h1>    
  </div>
  <div class="row" style="text-align:center">
    <button (click)="start()" class="btn btn-primary">Play</button>
    <button (click)="toggleControls()" class="btn btn-success">Toggle Controls</button>
    <button (click)="pause()" class="btn btn-warning">Pause</button>
    <button (click)="resume()" class="btn btn-info">Resume</button>
    <button (click)="sound()" class="btn btn-danger">Play with Sound</button>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class="text-center">
        <h3>
          <video #videoElement></video>
        </h3>
      </div>

    </div>

  </div>

</div>